import React from 'react';
import { FileEdit, Monitor, Search, Share, Zap, Globe } from 'lucide-react';
import './SaaSDevelopment.css';

const CMSSolutions = () => {
  return (
    <div className="saas-page">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-copy">
            <span className="eyebrow">Content Management</span>
            <h1>Manage Your Content with Ease and Versatility</h1>
            <p>
              Take control of your web presence with modern CMS solutions that 
              enable non-technical team members to update content instantly.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#contact">Choose Your CMS</a>
              <a className="button secondary" href="#platforms">Supported Platforms</a>
            </div>
          </div>
          <div className="hero-panel">
            <div className="panel-card panel-glow">
              <FileEdit className="icon" />
              <h3>User-Friendly</h3>
              <p>Visual editors and intuitive dashboards that require zero coding knowledge.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="platforms" className="section">
        <div className="section-heading">
          <span className="eyebrow">CMS Expertise</span>
          <h2>The right platform for the right job.</h2>
          <p>Whether you need a simple blog or a complex enterprise news portal, we have the experience to implement the perfect CMS.</p>
        </div>

        <div className="capabilities-grid">
          <div className="capability-card">
            <div className="cap-icon"><Zap size={24} /></div>
            <h3>Headless CMS</h3>
            <p>Modern solutions like Contentful or Strapi that deliver content via API to any device.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Monitor size={24} /></div>
            <h3>WordPress Customization</h3>
            <p>Moving beyond templates with custom themes and plugins for the world's most popular CMS.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Search size={24} /></div>
            <h3>SEO Optimization</h3>
            <p>Built-in tools to ensure your content is easily discoverable by search engines.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Share size={24} /></div>
            <h3>Multi-Channel</h3>
            <p>Publish once and distribute content across your website, mobile app, and social media.</p>
          </div>
        </div>
      </section>

      <section className="section bg-glass">
        <div className="solutions-container">
          <div className="solution-row reverse">
            <div className="solution-copy">
              <h3>Enterprise Grade Scalability</h3>
              <p>
                Our CMS implementations handle high traffic and massive content 
                libraries without sacrificing page load speed or security.
              </p>
              <ul className="feature-list">
                <li><Globe size={18} /> Multi-Language Support</li>
                <li><Globe size={18} /> High-Speed CDN Delivery</li>
                <li><Globe size={18} /> Granular Permission Control</li>
              </ul>
            </div>
            <div className="solution-media">
               <div className="panel-card panel-gradient">
                <FileEdit size={64} className="icon" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="metrics-grid">
        <div className="metric-item">
          <strong>50%</strong>
          <span>Faster Updates</span>
        </div>
        <div className="metric-item">
          <strong>90+</strong>
          <span>Core Web Vitals</span>
        </div>
        <div className="metric-item">
          <strong>100%</strong>
          <span>Mobile Ready</span>
        </div>
        <div className="metric-item">
          <strong>Unlimited</strong>
          <span>Content Pages</span>
        </div>
      </div>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Empower your content team today.</h2>
          <p>Let us build a CMS solution that grows with your business.</p>
          <a className="button primary" href="#contact">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default CMSSolutions;
